<div class="container">
    <div class="card">
        <div class="card-body">
            <div class="panel panel-primary">
                <div class="panel-heading custom-panel form-row">
                    <div class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                        <h2>Agenda Procedimento</h2>
                    </div>
                    <div class="menu-painel form-group col-lg-8 col-md-8 col-sm-8 col-12">
                        <button mat-stroked-button color="primary" (click)="addNovaAgenda()"
                            matTooltip="Novo Procedimento" [disabled]="!formularioDeAgendaProcedimento.valid"
                            style="margin-right: 5px; margin-bottom: 5px;">
                            Novo
                        </button>
                        <button mat-stroked-button color="warn" (click)="confirmDeleteLista()"
                            [disabled]="!temItemSelecionado()" matTooltip="Remover"
                            style="margin-right: 5px; margin-bottom: 5px;">Remover
                        </button>
                    </div>
                </div>

                <div class="panel-body" (window:resize)="onResize($event)">

                    <form [formGroup]="formularioDeAgendaProcedimento">

                        <div class="form-row">
                            <mat-form-field class="form-group col-lg-12 col-md-12 col-sm-12 col-12">
                                <mat-label>Procedimento</mat-label>
                                <mat-select value="Procedimento" formControlName="procedimento" name="procedimento"
                                    id="procedimento" required (selectionChange)="onChangeProcedimento($event)">
                                    <mat-option *ngFor="let procedimento of listaProcedimentos" [value]="procedimento">
                                        {{procedimento.nome}}
                                    </mat-option>
                                </mat-select>
                                <mat-error
                                    *ngIf="formularioDeAgendaProcedimento.controls.procedimento.hasError('required')">
                                    O campo Procedimento é obrigatório.
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="form-row">
                            <mat-form-field class="form-group col-lg-8 col-md-8 col-sm-8 col-12">
                                <mat-label>Médico</mat-label>
                                <mat-select value="Médico" formControlName="medico" name="medico" id="medico"
                                    (selectionChange)="onChangeMedico($event)">
                                    <mat-option [value]=""></mat-option>
                                    <mat-option *ngFor="let medico of listaMedicos" [value]="medico">
                                        {{medico.nome}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <mat-form-field class="form-group col-lg-4 col-md-4 col-sm-4 col-12">
                                <mat-label>Dia</mat-label>
                                <mat-select value="Dia" formControlName="diaSemana" name="diaSemana" id="diaSemana"
                                    (selectionChange)="onChangeDiaSemana($event)">
                                    <mat-option [value]=""></mat-option>
                                    <mat-option *ngFor="let diaSemana of listaDiasDaSemana" [value]="diaSemana.codigo">
                                        {{diaSemana.descricao}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                    </form>

                    <table mat-table [dataSource]="dataSource" matSort class="table table-striped">

                        <!-- Checkbox Column -->
                        <ng-container matColumnDef="select">
                            <th mat-header-cell *matHeaderCellDef>
                                <mat-checkbox (change)="$event ? masterToggle() : null"
                                    [checked]="selection.hasValue() && isAllSelected()"
                                    [indeterminate]="selection.hasValue() && !isAllSelected()"
                                    [aria-label]="checkboxLabel()">
                                </mat-checkbox>
                            </th>
                            <td mat-cell *matCellDef="let row">
                                <mat-checkbox (click)="$event.stopPropagation()"
                                    (change)="$event ? selection.toggle(row) : null"
                                    [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
                                </mat-checkbox>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="nomeFilial">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Filial </th>
                            <td mat-cell *matCellDef="let agendaProcedimento"> {{agendaProcedimento.nomeFilial}} </td>
                        </ng-container>

                        <ng-container matColumnDef="diaSemana">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Dia </th>
                            <td mat-cell *matCellDef="let agendaProcedimento"> {{agendaProcedimento.diaSemana |
                                diaSemanaPipe}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="horaAtendimento">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Hora </th>
                            <td mat-cell *matCellDef="let agendaProcedimento"> {{agendaProcedimento.horaAtendimento |
                                horaFormatadaPipe}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="quantidadeAtdGeral">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Qtd. </th>
                            <td mat-cell *matCellDef="let agendaProcedimento"> {{agendaProcedimento.quantidadeAtdGeral}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="atdIdadeMinima">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Idade Mín. </th>
                            <td mat-cell *matCellDef="let agendaProcedimento"> {{ agendaProcedimento.atdIdadeMinima}} </td>
                        </ng-container>

                        <ng-container matColumnDef="atdIdadeMaxima">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Idade Máx. </th>
                            <td mat-cell *matCellDef="let agendaProcedimento"> {{agendaProcedimento.atdIdadeMaxima}} </td>
                        </ng-container>

                        <ng-container matColumnDef="tomadasFormatadas">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Tomadas </th>
                            <td mat-cell *matCellDef="let agendaProcedimento"> {{agendaProcedimento.tomadasFormatadas}}
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="nomeMedico">
                            <th mat-header-cell *matHeaderCellDef mat-sort-header> Médico </th>
                            <td mat-cell *matCellDef="let agendaProcedimento"> {{agendaProcedimento.nomeMedico}} </td>
                        </ng-container>

                        <ng-container matColumnDef="details">
                            <th mat-header-cell *matHeaderCellDef class="table-column-center"> Ações </th>
                            <td mat-cell *matCellDef="let agendaProcedimento" class="table-column-center">
                                <button mat-icon-button color="primary"
                                    (click)="details(agendaProcedimento.pkProcedimentoAgenda)" matTooltip="Detalhar">
                                    <mat-icon class="mat-18">info</mat-icon>
                                </button>
                                <button mat-icon-button color="primary"
                                    (click)="update(agendaProcedimento.pkProcedimentoAgenda)" matTooltip="Alterar">
                                    <mat-icon class="mat-18">edit</mat-icon>
                                </button>
                                <button mat-icon-button color="warn"
                                    (click)="confirmDelete(agendaProcedimento.pkProcedimentoAgenda)"
                                    matTooltip="Remover">
                                    <mat-icon class="mat-18">delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
